import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import DeviceSwitch from '../../components/DeviceSwitch'
import TiefeLagen from '../TiefeLagen'
import MittlereLagen from '../MittlereLagen'
import HoheLagen from '../HoheLagen'
// import ExampleComponent from '../ExampleComponent'
import SmallMultipleComponent from 'components/SmallMultipleComponent'
import LanguageContent from '../../assets/language-content.json'



const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const windowSize = useWindowSize()
  const isMobile = windowSize.width > 641
  console.log("test", tenant)
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {(properties?.component === 'Cover' && isMobile) && <DeviceSwitch languageContent={(tenant?.lang === "fr") ? (LanguageContent.fr) : (LanguageContent.de)}/>}
      {properties?.component === 'TiefeLagen' && <TiefeLagen languageContent={(tenant?.lang === "fr") ? (LanguageContent.fr) : (LanguageContent.de)} />}
      {properties?.component === 'MittlereLagen' && <MittlereLagen languageContent={(tenant?.lang === "fr") ? (LanguageContent.fr) : (LanguageContent.de)}/>}
      {properties?.component === 'HoheLagen' && <HoheLagen languageContent={(tenant?.lang === "fr") ? (LanguageContent.fr) : (LanguageContent.de)}/>}
      {properties?.component === 'SmallMultiple' && (
        <TextWidthExtended>
          <SmallMultipleComponent
            headlineGrid={properties?.headlineGrid}
            leadGrid={properties?.leadGrid}
            dwSourceUrl={
              typeof properties?.dwSourceUrl === 'string'
                ? JSON.parse(properties?.dwSourceUrl)
                : properties?.dwSourceUrl
            }
            dwTitles={
              typeof properties?.dwTitles === 'string'
                ? JSON.parse(properties?.dwTitles)
                : properties?.dwTitles
            }
            dwDescriptions={
              typeof properties?.dwDescriptions === 'string'
                ? JSON.parse(properties?.dwDescriptions)
                : properties?.dwDescriptions
            }
            altitude={
              typeof properties?.altitude === 'string'
                ? JSON.parse(properties?.altitude)
                : properties?.altitude
            }
            number={
              typeof properties?.number === 'string'
                ? JSON.parse(properties?.number)
                : properties?.number
            }
            iFrameStyleHeight={properties?.iFrameStyleHeight}
            gridColumnsDesktop={typeof properties?.gridColumnsDesktop === 'string' ? parseInt(properties?.gridColumnsDesktop, 10) : properties?.gridColumnsDesktop}
            gridColumnsMobile={typeof properties?.gridColumnsMobile === 'string' ? parseInt(properties?.gridColumnsMobile, 10) : properties?.gridColumnsMobile}
            columnGapDesktop={properties?.columnGapDesktop}
            columnGapMobile={properties?.columnGapMobile}
            caption={properties?.caption}
            source={properties?.source}
            colorMode={colorMode}
          />
        </TextWidthExtended>
      )}
      {/* <TextWidth>
        <ExampleComponent />
      </TextWidth> */}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  /* z-index: 1; */
`
export default MainComponent
